// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import ScreenTitle from 'components/ScreenTitle';
import Header from 'components/Header';
import Footer from 'components/Footer';

const StockLayout = ({ children, title }) => {

	return (
		<div className='StockLayout'>
			
			<Header/>

			<Container>

				<ScreenTitle title={title}/>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

StockLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string
}

StockLayout.defaultProps = {
	children: null,
	title: ''
}

export default StockLayout